<template>
  <select-input
    v-model="selectedCountry"
    :errors="errors"
    :readonly="readonly"
    :label="$t('register.country')"
    :required="required"
  >
    <option :value="null" />
    <option
      v-for="country of countries"
      :key="country.code"
      :value="country.code"
    >{{ country.name }}</option>
  </select-input>
</template>

<script>
import SelectInput from "@/Shared/SelectInput";
import COUNTRIES from "@/Shared/Data/countries";

export default {
  components: {
    SelectInput
  },
  props: {
    value: [String, Number, Boolean],
    errors: Array,
    required: Boolean,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selectedCountry(selectedCountry) {
      this.$emit("input", selectedCountry);
    },
    value(selectedValue) {
      this.selectedCountry = selectedValue;
    }
  },
  data() {
    return {
      countries: COUNTRIES,
      selectedCountry: this.value
    };
  }
};
</script>